const multiGraphActions = {
  FETCH_GRAPH_DATA: 'FETCH_GRAPH_DATA',
  FETCH_GRAPH_DATA_SUCCESS: 'FETCH_GRAPH_DATA_SUCCESS',
  FETCH_GRAPH_DATA_ERROR: 'FETCH_GRAPH_DATA_ERROR',
  FETCH_GRAPH_DATA_CLEAN_STATE: 'FETCH_GRAPH_DATA_CLEAN_STATE',
};

const fetchGraphData = (data, callback = () => {}) => ({
  type: multiGraphActions.FETCH_GRAPH_DATA,
  payload: data,
  callback,
});
const fetchGraphDataSuccess = (data) => ({
  type: multiGraphActions.FETCH_GRAPH_DATA_SUCCESS,
  payload: data,
});
const fetchGraphDataError = ({ message }) => ({
  type: multiGraphActions.FETCH_GRAPH_DATA_ERROR,
  payload: message,
});
const fetchGraphDataCleanState = () => ({
  type: multiGraphActions.FETCH_GRAPH_DATA_CLEAN_STATE,
});

export {
  fetchGraphData,
  fetchGraphDataCleanState,
  fetchGraphDataError,
  fetchGraphDataSuccess,
  multiGraphActions,
};
